import { validator } from "@/utils/validator";

export const loginVerifySchema = validator.object().shape({
  code: validator.string().trim().emptyToNull().autoTransformToHalfWidth().label("認証コード").required(),
});
